import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentUser: null,
    error: null
    };

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        signInSuccess: (state, action) => {
            state.currentUser = action.payload;
            state.error = null;
        },
        signInFailure: (state, action) => {
            state.error = action.payload;
        },
        deleteUserSuccess(state, action) {
            state.currentUser = null;
            state.error = null;
          },
    }
});

export const { signInSuccess, signInFailure, deleteUserSuccess } = userSlice.actions;

export default userSlice.reducer;